/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type QuizsetCursorSearchReqContentType =
  (typeof QuizsetCursorSearchReqContentType)[keyof typeof QuizsetCursorSearchReqContentType];

export const QuizsetCursorSearchReqContentType = {
  ALL: 'ALL',
  QUIZSET: 'QUIZSET',
  FOLDER: 'FOLDER',
} as const;
